module.exports = __webpack_public_path__ + "static/img/index4(1)_08.c578c2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index4(1)_08.png
// module id = 3132
// module chunks = 1